import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { width = 24, height = 24, color = '#363531' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M11.607 2.111a.75.75 0 01.786 0l9.75 6A.75.75 0 0121.75 9.5H2.25a.75.75 0 01-.393-1.389l9.75-6zM4.9 8h14.2L12 3.63 4.9 8z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M5.25 8a.75.75 0 01.75.75v7.5a.75.75 0 01-1.5 0v-7.5A.75.75 0 015.25 8zM9.75 8a.75.75 0 01.75.75v7.5a.75.75 0 01-1.5 0v-7.5A.75.75 0 019.75 8zM14.25 8a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V8.75a.75.75 0 01.75-.75zM18.75 8a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M2.25 16.25A.75.75 0 013 15.5h9a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75zM.75 19.25a.75.75 0 01.75-.75H12a.75.75 0 010 1.5H1.5a.75.75 0 01-.75-.75zM22.696 14.62a.75.75 0 01.75.75v1.97a.75.75 0 01-.75.75h-1.969a.75.75 0 010-1.5h1.219v-1.22a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M18.75 15.641a2.854 2.854 0 00-2.02.838.75.75 0 01-1.062-1.06 4.355 4.355 0 016.163 0l1.394 1.39a.75.75 0 11-1.059 1.061l-1.394-1.39-.002-.001a2.855 2.855 0 00-2.02-.838zM14.054 19.66a.75.75 0 01.75-.75h1.97a.75.75 0 010 1.5h-1.22v1.22a.75.75 0 11-1.5 0v-1.97z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M14.273 19.131a.75.75 0 011.06-.001l1.395 1.39.002.001a2.856 2.856 0 004.04 0 .75.75 0 111.062 1.06 4.356 4.356 0 01-6.163 0l-1.394-1.389a.75.75 0 01-.002-1.06z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
